/*eslint-disable*/
import React, { Component } from "react";
import { Button, Modal } from "reactstrap";
import { Grid, Heading, GridItem } from "@chakra-ui/react";
import { connectModal } from "redux-modal";
import SaveIcon from "@material-ui/icons/Save";
import LeftMenu from "../component-questionnaire/LeftMenuBB/LeftMenu";
import MiddleMenu from "../component-questionnaire/MiddleMenuBB/MiddleMenu";

class ModalSurvey extends Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  save = () => {
    this.props.saveSurvey(this.props.Surveys);
    this.props.handleHide();
  };

  render() {
    const { show, handleHide, Surveys } = this.props;

    return (
      <>
        <Modal isOpen={show} style={{ maxWidth: "80%" }}>
          <Grid
            templateRows="repeat(5, -1fr)"
            templateColumns="repeat(6, 1fr)"
            gap={2}
          >
            <GridItem rowSpan={1} colSpan={6} bg="rgb(244, 244, 244)">
              <Heading
                size="lg"
                fontSize="50px"
                textAlign="center"
                verticalAlign="center"
              >
                Preview Questionnaire
              </Heading>
            </GridItem>
            <GridItem rowSpan={3} colSpan={2} bg="rgb(255, 255, 255)">
              {/* LEFT MENU SECTIONS */}
              <LeftMenu data={Surveys.sections} />
            </GridItem>
            <GridItem
              rowSpan={3}
              colSpan={4}
              bg="rgb(255, 255, 255)"
              w={["50%", "100%", "100%"]}
              style={{ overflow: "scroll" }}
            >
              {/* MIDDLE MENU SECTIONS */}
              <MiddleMenu Surveys={Surveys} />
            </GridItem>
            <GridItem
              colSpan={6}
              rowSpan={1}
              bg="rgb(244, 244, 244)"
              padding="2em"
            >
              <Button color="primary" onClick={this.save}>
                <SaveIcon />
              </Button>{" "}
              <Button color="secondary" onClick={handleHide}>
                Cancel
              </Button>
            </GridItem>
          </Grid>
        </Modal>
      </>
    );
  }
}

export default connectModal({ name: "survey" })(ModalSurvey);
